import * as BasicFontSize from './BasicFontSize';

// eslint-disable-next-line prefer-destructuring
export const FONT_SIZE_BASIC = BasicFontSize.FONT_SIZE_BASIC;

export const FONT_SIZE_LEAST = BasicFontSize.FONT_SIZE_012;

export const FONT_SIZE_XS = BasicFontSize.FONT_SIZE_014;

export const FONT_SIZE_SM = BasicFontSize.FONT_SIZE_016;

export const FONT_SIZE_MD = BasicFontSize.FONT_SIZE_020;

export const FONT_SIZE_LG = BasicFontSize.FONT_SIZE_024;

export const FONT_SIZE_XL = BasicFontSize.FONT_SIZE_030;

export const FONT_SIZE_2XL = BasicFontSize.FONT_SIZE_036;

export const FONT_SIZE_3XL = BasicFontSize.FONT_SIZE_048;

export const FONT_SIZE_4XL = BasicFontSize.FONT_SIZE_060;

const GenericFontSize = {
    FONT_SIZE_BASIC,
    FONT_SIZE_LEAST,
    FONT_SIZE_XS,
    FONT_SIZE_SM,
    FONT_SIZE_MD,
    FONT_SIZE_LG,
    FONT_SIZE_XL,
    FONT_SIZE_2XL,
    FONT_SIZE_3XL,
    FONT_SIZE_4XL,
};

export default GenericFontSize;
